import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=14612733&"
import script from "./MonacoEditor.vue?vue&type=script&lang=js&"
export * from "./MonacoEditor.vue?vue&type=script&lang=js&"
import style0 from "./MonacoEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports